import image1 from '@/assets/images/news/detail/20200924/1.gif';
import image2 from '@/assets/images/news/detail/20200924/2.gif';
import image3 from '@/assets/images/news/detail/20200924/3.gif';
import image4 from '@/assets/images/news/detail/20200924/4.gif';
import image5 from '@/assets/images/news/detail/20200924/5.gif';
import image6 from '@/assets/images/news/detail/20200924/6.gif';
import image7 from '@/assets/images/news/detail/20200924/7.gif';
import image8 from '@/assets/images/news/detail/20200924/8.gif';
import image9 from '@/assets/images/news/detail/20200924/9.gif';

export default {
  id: '20200924', //  模块 id
  title: '【乘风破浪，燃FUN叮咚】趣味运动会精彩集锦！', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text: '激情四射',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '2020叮咚趣味运动会已完满收官。本次运动会共计289人报名，7支团队，比赛现场竞争激烈，火爆，精彩纷呈，小编这就给大家送上精彩集锦^ ^',
      isIndent: false,
    },
    {
      type: 0,
      text: '开场仪式PART 01',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '运动员们踏着整齐的队形，有序入场，一共7支队伍参加比赛，分别是：鸿鹄队、怼怼队、烈火雄鹰队、VFun战队、乘风破浪的卜卜、活力队、太阳队。',
      isIndent: false,
    },
    {
      type: 0,
      text: '赛前预备PART 02',
      isIndent: false,
    },
    {
      type: 0,
      text: '热身环节，大家就已经开始',
      isIndent: false,
    },
    {
      type: 0,
      text: '各领风骚了…',
      isIndent: false,
    },
    {
      type: 0,
      text: 'Round1-凹造型',
      isIndent: false,
    },
    {
      type: 0,
      text: '周围都在动，就他俩不动',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: 'Round2-坐骑型',
      isIndent: false,
    },
    {
      type: 0,
      text: '我有坐骑我更HIGH',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: 'Round3-笑容型',
      isIndent: false,
    },
    {
      type: 0,
      text: '大家开心得就像一个孩子',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text: '比赛阶段PART 03',
      isIndent: false,
    },
    {
      type: 0,
      text: '比赛当天虽然淅淅沥沥地下着下雨',
      isIndent: false,
    },
    {
      type: 0,
      text: '但是这阻挡不了我们的热情',
      isIndent: false,
    },
    {
      type: 0,
      text: '乘风破浪，燃FUN叮咚，我们HIGH起！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 1,
      title: '',
      src: [image9],
    },
    {
      type: 0,
      text: '颁奖仪式PART 04',
      isIndent: false,
    },
    {
      type: 0,
      text: '经过紧张激烈的角逐，有哪些团队和个人得奖了呢？我们掌声祝贺！',
      isIndent: false,
    },
    {
      type: 0,
      text: '本期我们个人奖奖品',
      isIndent: false,
    },
    {
      type: 0,
      text: '一等奖：SKG颈椎按摩器（皮卡丘的电击）',
      isIndent: false,
    },
    {
      type: 0,
      text: '二等奖：美的电饭煲（中华小当家）',
      isIndent: false,
    },
    {
      type: 0,
      text: '三等奖：飞利浦电动牙刷（路飞的牙齿）',
      isIndent: false,
    },
    {
      type: 0,
      text: '你们猜对了吗？',
      isIndent: false,
    },
    {
      type: 0,
      text: '恭喜以下童鞋获得个人奖',
      isIndent: false,
    },
    {
      type: 0,
      text: '男子50米',
      isIndent: false,
    },
    {
      type: 0,
      text: '刘志玉、李涛、商鲲鹏',
      isIndent: false,
    },
    {
      type: 0,
      text: '女子50米',
      isIndent: false,
    },
    {
      type: 0,
      text: '白羽、李会芳、刘安妮',
      isIndent: false,
    },
    {
      type: 0,
      text: '男子立定跳远',
      isIndent: false,
    },
    {
      type: 0,
      text: '吴朝闻、杨锴、荆波',
      isIndent: false,
    },
    {
      type: 0,
      text: '女子立定跳远',
      isIndent: false,
    },
    {
      type: 0,
      text: '陈慧、王卫珍、梁莉芳',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '本次，我们团队奖统一送出的是现金，金额历年最多，恭喜以下团队获得团队奖：',
      isIndent: false,
    },
    {
      type: 0,
      text: '第一名：乘风破浪的卜卜',
      isIndent: false,
    },
    {
      type: 0,
      text: '奖金：4000元',
      isIndent: false,
    },
    {
      type: 0,
      text: '第二名：鸿鹄队',
      isIndent: false,
    },
    {
      type: 0,
      text: '奖金：3000元',
      isIndent: false,
    },
    {
      type: 0,
      text: '第三名：活力队',
      isIndent: false,
    },
    {
      type: 0,
      text: '奖金：2000元',
      isIndent: false,
    },
    {
      type: 0,
      text: '特别感谢PART 05',
      isIndent: false,
    },
    {
      type: 0,
      text: '金主爸爸：叮咚买菜工会委员会；',
      isIndent: false,
    },
    {
      type: 0,
      text: '水果支持：采销中心中心-全国水果基地开发部；',
      isIndent: false,
    },
    {
      type: 0,
      text: '主持人：蒋秀和；',
      isIndent: false,
    },
    {
      type: 0,
      text: '摄影团队：组织效能中心-季羽婷、周婧、江滕胤；',
      isIndent: false,
    },
    {
      type: 0,
      text: '所有现场工作人员。',
      isIndent: false,
    },
    {
      type: 0,
      text: '结语PART 06',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '感谢大家在本次运动会中的积极参与、激情燃fun、火力全开、协调配合，期待我们在接下去的工作当中，继续挥洒我们的激情，“乘风破浪，燃FUN叮咚”，叮咚有你更加精彩！',
      isIndent: false,
    },
  ],
};
